if (!customElements.get('ff-buy-buttons')) {
  customElements.define(
    'ff-buy-buttons',
    class FfBuyButtons extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
      }

      connectedCallback() {
        this.lensadvisorContainer = this.querySelector('.ff-buy-buttons__lensadvisor');
        this.placeholder = this.querySelector('.ff-buy-buttons__la-placeholder');
        this.isPrescription = this.dataset.prescription === 'true';
        this.btnClass = this.isPrescription
          ? this.dataset.submitClass
          : this.dataset.extraClass;
        this.textClass = this.isPrescription
          ? this.dataset.submitTextClass
          : this.dataset.extraTextClass;

        if (this.lensadvisorContainer) {
          this.setupLensAdvisorBtn();
          this.observeLensAdvisorBtn();
        }

        this.setupVariantListener();
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        if (this.boundVariantHandler) {
          document.removeEventListener('variant-selector:change', this.boundVariantHandler);
        }
        clearTimeout(this.placeholderTimeout);
      }

      setupLensAdvisorBtn() {
        const laBtn = this.querySelector('#la-select-lenses-btn');
        if (!laBtn) return;

        this.hidePlaceholder();

        if (laBtn.parentElement !== this.lensadvisorContainer) {
          this.lensadvisorContainer.appendChild(laBtn);
        }

        if (this.btnClass && !laBtn.classList.contains(this.btnClass)) {
          laBtn.classList.add(this.btnClass);
        }

        if (this.textClass && !laBtn.classList.contains(this.textClass)) {
          laBtn.classList.add(this.textClass);
        }

        this.lensadvisorContainer.style.removeProperty('display');
        laBtn.style.animation = 'ff-la-btn-reveal 0.35s ease forwards';
      }

      hidePlaceholder() {
        if (this.placeholder) {
          this.placeholder.style.display = 'none';
        }
        clearTimeout(this.placeholderTimeout);
      }

      setupVariantListener() {
        this.boundVariantHandler = (e) => {
          const { productId, variant } = e.detail;
          if (this.dataset.productId !== productId) return;
          this.updateSubmitButton(variant);
        };
        document.addEventListener('variant-selector:change', this.boundVariantHandler);
      }

      updateSubmitButton(variant) {
        const submitBtn = this.querySelector('[type="submit"]');
        const variantInput = this.querySelector('[name="id"]');
        if (!submitBtn) return;

        const isAvailable = variant && variant.available;

        if (variantInput) {
          variantInput.disabled = !isAvailable;
          if (variant) variantInput.value = variant.id;
        }

        submitBtn.disabled = !isAvailable;
        submitBtn.classList.toggle('ff-button-disabled', !isAvailable);
        submitBtn.classList.toggle('ff-button-container--unavailable', !isAvailable);
      }

      observeLensAdvisorBtn() {
        this.observer = new MutationObserver(() => {
          this.setupLensAdvisorBtn();
        });

        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
  );
}
